import {
  Box,
  Card,
  CardContent,
  Grid,
  Stack,
  Tooltip,
  Typography,
} from "@mui/material";
import React from "react";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../../utils/commonUtils";
export default function CounterSalesItemCard({ item }) {
  return (
    <Card
      sx={{
        width: "96%",
        mt: "5px",
        cursor: "pointer",
        backgroundColor: "#E3E3FF",
        "& .MuiCardContent-root": { p: "0rem" },
        borderRadius: "9px",
        padding: "10px ",
        paddingLeft: {xs:"10px", sm:"30px"},
        boxShadow: "none",
      }}
    >
      <CardContent sx={{ padding: "0rem 0.7rem !important" }}>
        <Grid container>
          <Grid item xs={0} sm={1}></Grid>

          <Grid item xs={4} sm={3}>
            <Typography
              color="primary"
              sx={{
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 500,
                fontFamily: "'Montserrat', sans-serif",
                color: "black",
                px: { xs: "0px", sm: "22px" },
                textAlign: "center",

                borderRadius: "10px",
              }}
            >
              {item?.billDate
                ? convertDateToCustomFormat(item?.billDate?.split("T")[0])
                : convertDateToCustomFormat(item?.createdDate?.split("T")[0])}
            </Typography>
          </Grid>

          <Grid item xs={4}>
            <Typography
              color="primary"
              sx={{
                textAlign: "center",
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
                // overflow: "Hidden",
                // display: "-webkit-box",
                // "-webkit-line-clamp": "1",
                // "-webkit-box-orient": "vertical",
                fontWeight: 500,
                fontFamily: "'Montserrat', sans-serif",
                color: "black",
                px: {sm:"10px", xs:"0px"},
                borderRadius: "10px",
              }}
            >
              {item?.name}
            </Typography>
          </Grid>

          <Grid item xs={3} sx={{ pl: {sm:5, md:10, xs:0, lg:20}, pr: {xs:10, md:10, sm:10, lg:20} }}>
            {/* <Box p={1} px={12}> */}
            <Box
              display="flex"
              // justifyContent="justify-end"
              alignItems="center"
              sx={{ width: "100%" }}
            >
              <CurrencyRupeeIcon sx={{ fontSize: "16px", color: "#000" }} />
              <Typography
                fontWeight={500}
                align="center"
                sx={{
                  flex: 1,
                  textAlign: "right",
                  fontSize: { xs: "12px", sm: "13px", md: "15px" },
                }}
              >
                {item.amount?.toFixed(2)}
              </Typography>
            </Box>
            {/* </Box> */}
          </Grid>
          <Grid item xs={1}></Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}
